import { css } from '@emotion/react';
import { SuccessGraphic } from '@frontend/assets';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Icon, Text, TextLink } from '@frontend/design-system';
import { CreateSoftphonePropTypes } from '..';

export const SuccessPage = ({ values }: CreateSoftphonePropTypes) => {
  const { t } = useTranslation('devices', { keyPrefix: 'new-softphone' });

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing(2)};
      `}
    >
      <Icon
        size={200}
        css={css`
          margin: 0px auto;
        `}
      >
        <SuccessGraphic />
      </Icon>
      <Text>
        <Trans t={t} firstName={values?.firstName}>
          <b>{values?.firstName}</b> can now access their softphone in the Weave app.
        </Trans>
      </Text>
      <Text>
        <Trans t={t} deviceName={values?.deviceName ?? ''}>
          To further customize the use of <b>{values?.deviceName}</b>, you can assign it to Call Groups, Call Queues,
          and directly route incoming calls to it in
          <TextLink
            target='_blank'
            rel='noreferrer'
            href='https://www.weavehelp.com/weavehelp/article/call-routing-guide'
          >
            {' '}
            Call Routes.
          </TextLink>
        </Trans>
      </Text>
    </div>
  );
};
